// src/components/common/SEOHead.js
// Shared SEO head component using react-helmet-async
// Replaces manual useEffect DOM manipulation across all public pages

import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.driftalarm.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-image.png`;

function SEOHead({ title, description, path, ogImage, ogType = 'website', jsonLd }) {
  const canonicalUrl = `${SITE_URL}${path}`;
  const image = ogImage || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* OpenGraph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={image} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        Array.isArray(jsonLd)
          ? jsonLd.map((schema, i) => (
              <script key={i} type="application/ld+json">
                {JSON.stringify(schema)}
              </script>
            ))
          : <script type="application/ld+json">
              {JSON.stringify(jsonLd)}
            </script>
      )}
    </Helmet>
  );
}

export default SEOHead;
